export function YtKontrolaPib(broj:string):string{
    let suma:number = 10;
    for(let i:number = 0; i<8; i++){
        suma = (suma + parseInt(broj.charAt(i),10)) % 10;
        suma = (suma == 0 ? 10 : suma) * 2 % 11;
    }
    suma = (11 - suma) % 10;
    return suma.toString();
}